export default __webpack_public_path__ + "static/media/preview-course(1).c8392a2d.png";